import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';
import {TwapAlgoParamsError} from './twap-algo-params-errors';

@Component({
    selector: 'widget-order-twap-algo-params-alert',
    templateUrl: 'widget-order-twap-algo-params-alert.component.html',
    styleUrls: ['../../widget-inner-alert/widget-inner-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderTwapAlgoParamsAlertComponent
    extends WidgetInnerAlertComponent
    implements OnInit {

    public override readonly title: string = 'components.widgets.trade-widget.twap_error_title';

    @Input()
    public twapAlgoParamsErrors: TwapAlgoParamsError[];

    public readonly TwapAlgoParamsError = TwapAlgoParamsError;

}
